import React from "react";

import { Field } from "../../utils/components/form";
import { InputError, Tooltip } from '.';

export const DropDownRow = (props = {}) => {
  const { name, label, placeholder, tooltip, children, ...attributes } = props;

  return <tr className="bg-white">
    <td>
      <label className="fs-5 text-gray">
        {label}
        <Tooltip>{tooltip}</Tooltip>
      </label>
    </td>
    <td>
      <Field
        name={name}
        {...attributes}
      >
        {(formProps) => {
          return (
            <>
              <select {...formProps.input}
                {...attributes}
                className="form-control form-select-lg form-select">
                <option value="none">Bitte auswählen</option>
                {children}
              </select>
              <InputError {...formProps} />
            </>
          );
        }}
      </Field>
    </td>
  </tr>;

};
